import React, { useState } from 'react';
import { images } from '../../constants';
import { AppWrap, MotionWrap } from '../../wrapper';
import { client } from '../../client';
import './Footer.scss';

const Footer = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const { name, email, message } = formData;

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = () => {
    // Sanitize input
    const trimmedName = name.trim();
    const trimmedEmail = email.trim();
    const trimmedMessage = message.trim();

    // Check if any field is empty
    if (!trimmedName && !trimmedEmail && !trimmedMessage) {
      alert('Please fill at least one field before submitting.');
      return;
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(trimmedEmail)) {
      alert("Please enter a valid email address.");
      return;
    }

    // Proceed with submission
    setLoading(true);

    const contact = {
      _type: 'contact',
      name: trimmedName,
      email: trimmedEmail,
      message: trimmedMessage,
    };

    client.create(contact).then(() => {
      setLoading(false);
      setIsFormSubmitted(true);
    }).catch((err) => {
      setLoading(false);
      console.error(err);
      alert('Something went wrong. Please try again.');
    });
  };

  return (
    <>
      <h2 className="head-text">Let's Connect</h2>

      <div className="app_footer-cards">
        <div className="app_footer-card">
          <img src={images.gmail} alt="gmail" />
          <a href="mailto:kaushalbikram44@gmail.com" className="p-text">Kaushalbikram44@gmail.com</a>
        </div>
        <div className="app_footer-card">
          <img src={images.phone} alt="mobile" />
          <a href="tel:+9779764233148" className="p-text">+977 9764233148</a>
        </div>
      </div>

      {!isFormSubmitted ? (
        <div className="app_footer-form app_flex">
          <div className="app_flex">
            <input
              className="p-text"
              type="text"
              placeholder="Your Name"
              name="name"
              value={name}
              onChange={handleChangeInput}
            />
          </div>
          <div className="app_flex">
            <input
              className="p-text"
              type="email"
              placeholder="Your Email"
              name="email"
              value={email}
              onChange={handleChangeInput}
            />
          </div>
          <div>
            <textarea
              className="p-text"
              placeholder="Your Message"
              name="message"
              value={message}
              onChange={handleChangeInput}
            />
          </div>
          <button type="button" className="p-text" onClick={handleSubmit}>
            {loading ? 'Sending...' : 'Send Message'}
          </button>
        </div>
      ) : (
        <div>
          <h3 className="head-text">Thank You For Getting In Touch</h3>
        </div>
      )}
    </>
  );
};

export default AppWrap(
  MotionWrap(Footer, 'app_footer'),
  'Contact',
  'app_primarybg'
);



